import * as React from 'react';
import { purinaCallUrl } from 'Src/constants/paths';
import { counterTrigger } from 'Tools/counters';
import Button from '@media-ui/core/src/components/Button';
import Quote from '@media-ui/article/src/components/Blockquote';
import CallIcon from '@paradigm/icons/src/mailru/actions/call.svg';
import * as T from './ExpertQuote.types';
import * as s from './ExpertQuote.css';
const ActionButtons: React.FunctionComponent<T.ExpertQuote> = (props) => (<div className={s.buttons}>
    <div className={s.buttonWrap}>
      <Button.Link className={s.button} target="_blank" theme="simple" href={props.author_ask_href}>
        Задать вопрос
      </Button.Link>
    </div>
    <div className={s.buttonWrap}>
      <Button.Link className={s.button} target="_blank" theme="primary" href={purinaCallUrl} onClick={() => counterTrigger('callButtonExpertQuote')}>
        <div className={s.iconWrap}>
          <CallIcon />
        </div>
        <span>Позвонить</span>
      </Button.Link>
    </div>
  </div>);
export const ExpertQuote: React.FunctionComponent<T.ExpertQuote> = (props) => (<Quote {...props} action={<ActionButtons {...props}/>}/>);
